import {Switch, Redirect, Route} from 'react-router-dom'
import {MainRoutingStyled} from './MainRoutingStyled'
import LoginGate from '../login/LoginGate'
import {PATHS, STATUS} from 'src/constants/constants'
import MainRoutingPagesGate from 'src/pages-new/mainRouting/MainRoutingPagesGate'
import PasswordRecoveryGate from 'src/pages-new/passwordRecovery/PasswordRecoveryGate'
import ChangePortalPage from '../changePortal/ChangePortalPage'
import ChangePortalPageNew from 'src/pages-new/changePortal/ChangePortalPageNew'
import {NEW_PATHS} from 'src/pages-new/mainRouting/routesMap'
import {useAppSelector} from 'src/hooks'
import PDFSummary from 'src/pdf/Summary/PDFSummary'
import {useEffect} from 'react'
import PatientDigitalEnrollmentGate from 'src/pages-new/patientDigitalEnrollment/PatientDigitalEnrollmentGate'
import PDFDiary from 'src/pdf/PDFDiary/PDFDiary'
import SelfRegistrationGate from 'src/pages-new/selfRegistration/SelfRegistrationGate'

function MainRouting () {
  const pspConfig = useAppSelector(state => state.pspConfigReducer.data)
  const statusConfig = useAppSelector(({pspConfigReducer}) => pspConfigReducer.status)
  const statusUserInfo = useAppSelector(({userReducer}) => userReducer.status)
  const {summaryConfiguration, therapyDiaryConfigurations, patientDetailConfiguration} = useAppSelector(state => state.pspConfigReducer.data)
  const diaryExportEnabled = (pspConfig.sidebarItems?.therapyDiary?.show || patientDetailConfiguration?.tabs?.diary?.show) &&
    (therapyDiaryConfigurations?.showExport || patientDetailConfiguration?.diaryConfigurations?.showExport)

  useEffect(() => {
    const link = document.querySelector('link[rel="shortcut icon"]')
    const title = document.querySelector('title')
    if (title && pspConfig.PSPTitleAndIcon.title) {
      document.title = pspConfig.PSPTitleAndIcon?.title
    }
    if (link && pspConfig.PSPTitleAndIcon.icon) {
      link.setAttribute('href', `data:image/png;base64,${pspConfig.PSPTitleAndIcon.icon}`)
    }
  }, [pspConfig])

  return (
    <MainRoutingStyled>
      <Switch>
        <Route component={LoginGate} path={PATHS.LOGIN} />
        <Route component={PasswordRecoveryGate} path={PATHS.PASSWORD_RECOVERY} />
        <Route component={ChangePortalPage} path={PATHS.PORTALS} />
        <Route component={ChangePortalPageNew} path={NEW_PATHS.PORTALS} />
        <Route component={PatientDigitalEnrollmentGate} path={PATHS.PATIENT_DIGITAL_ENROLLMENT} />
        <Route component={SelfRegistrationGate} path={PATHS.AUTO_REGISTRATION} />
        {(statusConfig === STATUS.FULFILLED && statusUserInfo === STATUS.FULFILLED) && pspConfig.sidebarItems.summary?.show && summaryConfiguration.enableExport &&
          <Route component={PDFSummary} path={`/${PATHS.PDF_SUMMARY}`} />}
        {(statusConfig === STATUS.FULFILLED && statusUserInfo === STATUS.FULFILLED) && diaryExportEnabled &&
          <Route component={PDFDiary} path={`/${PATHS.PDF_DIARY}`} />}
        <Switch>
          <MainRoutingPagesGate />
        </Switch>
        <Redirect to={PATHS.SUMMARY} />
      </Switch>
    </MainRoutingStyled>
  )
}

export default MainRouting
